import { jsx as _jsx } from "react/jsx-runtime";
import { isNonNaNNumber } from '@iotv/iotv-v3-types';
import { Stack } from '@mui/material';
import { TimelineChart } from '../../../../charts/TImeline';
const debug = process.env.REACT_APP_DEBUG && false;
/* 2024 12
    - spawned from SheduleTimeline
*/
const defaultTimelineOptions = {
    hAxis: {
        format: 'EEE H:00',
    },
    timeline: {
        showRowLabels: true,
    },
    alternatingRowStyle: false,
};
export const EntityProgammeTimelineChart = ({ dataTable, setDateRangeMs, fragmentProps, timelineOptions }) => {
    const fromDateColIdx = 3;
    const toDateColIdx = 4;
    /* injects date mutation via bar click into chart */
    const select = (timelineChart, dataTable) => () => {
        const selection = timelineChart?.getSelection();
        debug && console.log(`ScheduleTimelineChart select`, selection);
        if (selection && dataTable) {
            const nr = dataTable.getNumberOfRows();
            const nc = dataTable.getNumberOfColumns();
            /** get spanned range (multiple possible selections) */
            const { fromDate, toDate } = selection.reduce((a, rc) => {
                const { column, row } = rc; // column removed as in this usage it is returned as null - because rows are displayed on one line?
                if (isNonNaNNumber(row) && row < nr && fromDateColIdx < nc && toDateColIdx < nc) {
                    const fromDate = dataTable.getValue(row, fromDateColIdx);
                    const toDate = dataTable.getValue(row, toDateColIdx);
                    console.log({ fromDate, toDate });
                    if (fromDate instanceof Date && toDate instanceof Date) {
                        if (a.fromDate === null || a.fromDate > fromDate) {
                            a.fromDate = fromDate;
                        }
                        if (a.toDate === null || a.toDate < toDate) {
                            a.toDate = toDate;
                        }
                    }
                    else {
                        console.log(`WARN: did not get dates from row ${row}, columns ${fromDateColIdx}, ${toDateColIdx}. This selection function is currently hard coded to DataTableRow: [ rowHeader: string, itemName:  string, style: string, fromDate: Date, toDate: Date ]`);
                    }
                }
                return a;
            }, { fromDate: null, toDate: null });
            if (fromDate && toDate && setDateRangeMs) {
                const f = fromDate.valueOf();
                const t = toDate.valueOf();
                const d = t - f;
                setDateRangeMs({ fromDateMs: f - d / 2, toDateMs: t + d / 2 });
                timelineChart.clearChart();
                // dispatch( { fromDateValue: dayjs( fromDate ), toDateValue: dayjs( toDate )})
            }
        }
    };
    const params = {
        dataTable,
        fragmentProps: fragmentProps ?? { style: { height: 300, width: '100%' } },
        options: { ...defaultTimelineOptions, ...timelineOptions },
        listenerFns: {
            select,
        },
    };
    return dataTable ? (_jsx(Stack, { width: "100%", children: _jsx(Stack, { direction: "row", children: _jsx(TimelineChart, { ...params }) }) })) : null;
};
